import { useField } from "formik";
import React from "react";

export type ReadOnlyTextFieldProps = Readonly<{
  name: string;
  fallbackFieldName?: string;
}>;

export const ReadOnlyTextField = (props: ReadOnlyTextFieldProps) => {
  const [field] = useField({ name: props.name });
  const [fallbackField] = useField({ name: props.fallbackFieldName ?? props.name });
  const value = field.value || fallbackField.value;
  return <span>{value ?? ""}</span>;
};
